import React, { useEffect } from 'react';
import '../styles/Moderation.css';

const HTML = `
<div class="topbar">
      <div class="breadcrumb">
        <span>Cambérène</span><span class="sep">/</span>
        <span>Admin</span><span class="sep">/</span>
        <b>Modération</b>
      </div>
      <div class="search">
        <span class="ic"></span>
        <input type="text" placeholder="Chercher un auteur, un signalement, un mot-clé…" />
        <kbd>⌘ K</kbd>
      </div>
      <div class="top-actions">
        <button class="icon-btn" title="Filtres avancés">⚏</button>
        <button class="icon-btn" title="Notifications">◉<span class="dot"></span></button>
        <a class="top-cta" href="#">⥥ Journal</a>
      </div>
    </div>

    <div class="content">

      <!-- Page head -->
      <div class="page-head">
        <div>
          <span style="font-family:var(--mono); font-size:11px; letter-spacing:.22em; text-transform:uppercase; color:var(--char-500)">File d'attente · 19 Mai 2026 · 14h32</span>
          <h1>Garder le village<br /><span class="ital">propre &amp; vivant.</span></h1>
          <p class="sub">28 éléments à examiner. Approuvez, rejetez ou escaladez aux commissions. Toute action est journalisée et révocable 24 h.</p>
        </div>
        <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap">
          <button class="pill-btn">⌖ Vue carte</button>
          <button class="pill-btn">↓ Exporter</button>
          <button class="pill-btn on">⚡ Mode rapide</button>
        </div>
      </div>

      <!-- KPI strip -->
      <div class="strip">
        <div class="kpi urgent">
          <div class="lab"><span class="dot"></span> En attente · maintenant</div>
          <b>28</b>
          <span class="delta" style="background:rgba(255,107,107,.2); color:#FFB4B4">3 urgents · délai &lt; 6 h</span>
        </div>
        <div class="kpi">
          <div class="lab"><span class="dot" style="background:var(--ok)"></span> Traités · aujourd'hui</div>
          <b>47</b>
          <span class="delta up">▲ +12 vs hier</span>
        </div>
        <div class="kpi">
          <div class="lab"><span class="dot" style="background:var(--ocean-600)"></span> Délai moyen</div>
          <b>1h 42</b>
          <span class="delta up">▼ −18 min · semaine</span>
        </div>
        <div class="kpi">
          <div class="lab"><span class="dot" style="background:var(--gold)"></span> Taux d'approbation</div>
          <b>82<span style="font-size:.45em; color:var(--char-500); margin-left:2px">%</span></b>
          <span class="delta">Sur 7 derniers jours</span>
        </div>
      </div>

      <!-- Work area -->
      <div class="work">

        <!-- ============ QUEUE ============ -->
        <section class="panel">
          <div class="panel-head">
            <div>
              <h3>File d'attente</h3>
              <p>Sélectionnez un élément pour le prévisualiser à droite. Actions par lots dispo.</p>
            </div>
            <div class="actions">
              <button class="pill-btn">Trier · Plus récent ▾</button>
              <button class="pill-btn">Affichage · Liste</button>
            </div>
          </div>

          <!-- Tabs -->
          <div class="qtabs">
            <button class="on"><span class="ico">◇</span> Tout <span class="ct">28</span></button>
            <button><span class="ico">❝</span> Commentaires <span class="ct">12</span></button>
            <button><span class="ico">◳</span> Photos <span class="ct">8</span></button>
            <button><span class="ico">◧</span> Commerces <span class="ct">3</span></button>
            <button><span class="ico">⚑</span> Signalements <span class="ct">3</span></button>
            <button><span class="ico">★</span> Talents <span class="ct">2</span></button>
          </div>

          <!-- Bulk bar (shown when selection) -->
          <div class="bulkbar on">
            <span class="ck on" id="bulk-ck"></span>
            <b>2 sélectionnés</b>
            <span class="spacer"></span>
            <button class="bulk-btn approve">✓ Approuver</button>
            <button class="bulk-btn reject">× Rejeter</button>
            <button class="bulk-btn escalate">⚑ Escalader</button>
            <button class="bulk-btn">⋯ Plus</button>
          </div>

          <!-- Filter bar -->
          <div class="filterbar">
            <span class="lab">Sévérité</span>
            <button class="chip on">Tout</button>
            <button class="chip"><i class="sev high"></i> Haute · 3</button>
            <button class="chip"><i class="sev med"></i> Moyenne · 11</button>
            <button class="chip"><i class="sev low"></i> Basse · 14</button>
            <span class="lab" style="margin-left:14px">Auteur</span>
            <button class="chip">Tous</button>
            <button class="chip">Membres vérifiés</button>
            <button class="chip">Nouveaux</button>
            <span class="spacer"></span>
            <div class="mini-search"><span style="opacity:.6">🔎</span><input placeholder="Filtrer la file…" /></div>
          </div>

          <!-- Queue items -->
          <div class="queue">

            <!-- 1 — Selected (preview corresponds) -->
            <div class="qitem selected" data-id="1">
              <span class="ck on" data-stop></span>
              <div class="qthumb text" aria-hidden="true"></div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Khadim Sow</span>
                  <span class="when">· 32 min · « Plage propre »</span>
                </div>
                <p class="text">« Bravo aux jeunes, mais il faudrait que la mairie envoie aussi un camion benne le dimanche, sinon les sacs traînent toute la nuit et… »</p>
                <div class="tags">
                  <span class="tag comment">Commentaire</span>
                  <span class="sev-tag low">Sév. basse</span>
                </div>
              </div>
              <div>
                <span class="sev-tag" style="background:var(--bone-2); color:var(--char-500); border:1px solid var(--line)">en attente</span>
              </div>
              <div class="qactions">
                <button class="qa-btn approve" title="Approuver (A)">✓</button>
                <button class="qa-btn reject" title="Rejeter (R)">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 2 -->
            <div class="qitem" data-id="2">
              <span class="ck on" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-pirogue/120/120')">
                <div class="ovl"></div>
                <div class="kind">PHOTO</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Mor Sène</span>
                  <span class="when">· 1 h · Galerie · Plage Nord</span>
                </div>
                <p class="text">Soumission photo : « Pirogues à l'aube — 6h12 ». 4032×3024 · 3.4 Mo · EXIF Cambérène (14.78°N).</p>
                <div class="tags">
                  <span class="tag photo">Photo galerie</span>
                  <span class="tag draft">Album · Pirogues</span>
                  <span class="sev-tag low">Sév. basse</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 3 — Flagged urgent -->
            <div class="qitem" data-id="3">
              <span class="ck" data-stop></span>
              <div class="qthumb text">❝</div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Anonyme · IP 41.82.x.x</span>
                  <span class="when">· 2 h · Profil Aïssatou N.</span>
                </div>
                <p class="text">« Cette personne ne devrait pas avoir le droit de chanter ici, c'est une honte pour notre… » <em>[contenu tronqué]</em></p>
                <div class="tags">
                  <span class="tag comment">Commentaire</span>
                  <span class="tag flag">Haine · IA 94%</span>
                  <span class="sev-tag high">Sév. haute</span>
                </div>
              </div>
              <div><span class="sev-tag high">URGENT</span></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 4 -->
            <div class="qitem" data-id="4">
              <span class="ck" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-cafe-sud/120/120')">
                <div class="ovl"></div><div class="kind">COMMERCE</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Idrissa Fall</span>
                  <span class="when">· 3 h · Annuaire</span>
                </div>
                <p class="text">Nouveau commerce soumis : <b>Café Sud</b> — Restaurant · Rue 14 Cambérène · ouverture juin 2026. 5 photos jointes.</p>
                <div class="tags">
                  <span class="tag biz">Commerce</span>
                  <span class="tag draft">Restaurant</span>
                  <span class="sev-tag med">Sév. moyenne</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 5 — Signalement -->
            <div class="qitem" data-id="5">
              <span class="ck" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-lampadaire/120/120')">
                <div class="ovl"></div><div class="kind">SIGNAL.</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Awa Diagne</span>
                  <span class="when">· 5 h · Signalement #0421</span>
                </div>
                <p class="text">Lampadaire éteint depuis 4 jours · Rue 14, devant la mosquée · zone peu sûre le soir, plusieurs voisins ont confirmé.</p>
                <div class="tags">
                  <span class="tag signal">Signalement</span>
                  <span class="tag draft">Voirie</span>
                  <span class="sev-tag med">Sév. moyenne</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 6 -->
            <div class="qitem" data-id="6">
              <span class="ck" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-talent/120/120')">
                <div class="ovl"></div><div class="kind">TALENT</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Fatima Diallo</span>
                  <span class="when">· 6 h · Demande de profil Talent</span>
                </div>
                <p class="text">Demande d'inscription au catalogue Talents — catégorie « Artisan / Couture ». Bio + 3 photos d'ouvrages jointes.</p>
                <div class="tags">
                  <span class="tag talent">Talent</span>
                  <span class="tag draft">Artisan</span>
                  <span class="sev-tag low">Sév. basse</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 7 — flagged -->
            <div class="qitem" data-id="7">
              <span class="ck" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-spam/120/120')">
                <div class="ovl"></div><div class="kind">PHOTO</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">user_82d4</span>
                  <span class="when">· 8 h · Galerie · Aucun album</span>
                </div>
                <p class="text">Photo soumise sans contexte ni géo-tag. Le système détecte une similarité 86% avec du contenu déjà refusé. Auteur sans historique.</p>
                <div class="tags">
                  <span class="tag photo">Photo</span>
                  <span class="tag flag">Spam · IA 86%</span>
                  <span class="sev-tag high">Sév. haute</span>
                </div>
              </div>
              <div><span class="sev-tag high">URGENT</span></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 8 -->
            <div class="qitem" data-id="8">
              <span class="ck" data-stop></span>
              <div class="qthumb text">❝</div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Omar Sow</span>
                  <span class="when">· 9 h · Article « Grand Appel »</span>
                </div>
                <p class="text">« Que Allah accepte les prières du village. Beaucoup d'entre nous suivront depuis Paris cette année grâce au direct. Merci pour ce travail… »</p>
                <div class="tags">
                  <span class="tag comment">Commentaire</span>
                  <span class="sev-tag low">Sév. basse</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

            <!-- 9 -->
            <div class="qitem" data-id="9">
              <span class="ck" data-stop></span>
              <div class="qthumb" style="background-image:url('https://picsum.photos/seed/cb-mod-pothole/120/120')">
                <div class="ovl"></div><div class="kind">SIGNAL.</div>
              </div>
              <div class="qmeta">
                <div class="row1">
                  <span class="who">Cheikh Diop</span>
                  <span class="when">· hier · Signalement #0420</span>
                </div>
                <p class="text">Nid de poule profond à l'entrée du stade — danger pour les motos. Photo + géoloc précise (14.7821°N, 17.4502°O).</p>
                <div class="tags">
                  <span class="tag signal">Signalement</span>
                  <span class="tag draft">Voirie</span>
                  <span class="sev-tag med">Sév. moyenne</span>
                </div>
              </div>
              <div></div>
              <div class="qactions">
                <button class="qa-btn approve">✓</button>
                <button class="qa-btn reject">×</button>
                <button class="qa-btn more">⋯</button>
              </div>
            </div>

          </div>

          <div class="qfoot">
            <span>9 sur 28 affichés · 19 restants</span>
            <div class="pager">
              <button>‹</button>
              <button class="on">1</button>
              <button>2</button>
              <button>3</button>
              <button>›</button>
            </div>
          </div>
        </section>

        <!-- ============ DETAIL ============ -->
        <aside class="detail">
          <div class="detail-panel">
            <div class="detail-head">
              <div style="position:relative">
                <span class="lab">Commentaire · #C0428 · Sévérité basse</span>
                <h4>Khadim Sow<br /><span style="font-style:italic; color:rgba(250,246,238,.7); font-size:14px">sur « Plage propre : 380 kg de déchets retirés »</span></h4>
              </div>
              <button class="close" title="Fermer">×</button>
            </div>

            <div class="detail-body">

              <div class="author">
                <span class="av"></span>
                <div style="min-width:0">
                  <div class="nm">Khadim Sow</div>
                  <div class="roles">
                    <span>Habitant</span><i></i>
                    <span>Cambérène · Plage</span><i></i>
                    <span>Membre depuis 2024</span>
                  </div>
                </div>
                <div class="rep">
                  <b>92</b>
                  <small>Réputation</small>
                </div>
              </div>

              <div class="flag-card">
                <div class="top">
                  <b>⚠ Analyse automatique · Aucun risque détecté</b>
                  <span class="conf">Confiance 96%</span>
                </div>
                <p>Ton constructif, vocabulaire neutre. Aucune correspondance avec les listes de mots sensibles ni avec les profils de spam connus. Recommandation : <b>approuver</b>.</p>
                <div class="flag-bars" aria-hidden="true">
                  <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                </div>
              </div>

              <div class="field-group">
                <div class="k">Contenu du commentaire</div>
                <div class="v quote">« Bravo aux jeunes, mais il faudrait que la mairie envoie aussi un camion benne le dimanche, sinon les sacs traînent toute la nuit et finissent par s'éparpiller au matin. Beau travail quand même, on est nombreux à apprécier l'initiative. »</div>
              </div>

              <div class="field-group" style="display:grid; grid-template-columns:1fr 1fr; gap:14px">
                <div>
                  <div class="k">Soumis</div>
                  <div class="v">19 Mai · 14h00</div>
                </div>
                <div>
                  <div class="k">Article cible</div>
                  <div class="v">Plage propre · #N142</div>
                </div>
                <div>
                  <div class="k">Langue</div>
                  <div class="v">Français</div>
                </div>
                <div>
                  <div class="k">Sentiment</div>
                  <div class="v" style="color:#1F7A3A">★ Positif (0.72)</div>
                </div>
              </div>

              <div class="field-group">
                <div class="k">Motif (si rejet)</div>
                <div class="reasons">
                  <div class="reason"><span class="rb"></span> <span>Hors-sujet</span></div>
                  <div class="reason"><span class="rb"></span> <span>Propos haineux ou discriminatoires</span></div>
                  <div class="reason"><span class="rb"></span> <span>Spam · publicité</span></div>
                  <div class="reason"><span class="rb"></span> <span>Données personnelles divulguées</span></div>
                  <div class="reason"><span class="rb"></span> <span>Autre…</span></div>
                </div>
              </div>

              <div class="field-group">
                <div class="k">Note interne (équipe seulement)</div>
                <textarea placeholder="Ajouter une note visible uniquement par l'équipe de modération…" style="width:100%; min-height:64px; padding:12px 14px; border:1px solid var(--line-strong); border-radius:10px; background:var(--bone); resize:vertical; font-size:13.5px"></textarea>
              </div>
            </div>

            <div class="detail-foot">
              <button class="verdict-btn approve">✓ Approuver <span class="kbd">A</span></button>
              <button class="verdict-btn reject">× Rejeter <span class="kbd">R</span></button>
              <button class="verdict-btn escalate">⚑ Escalader <span class="kbd">E</span></button>
            </div>
          </div>

          <!-- Audit -->
          <div class="side-panel">
            <h4>Décisions récentes</h4>
            <div class="audit-row">
              <span class="av" style="background-image:url('https://picsum.photos/seed/cb-team-aminata/80/80')"></span>
              <div class="text"><b>Aminata Diop</b> a <span class="verdict ok">approuvé</span> 6 commentaires sur « Plage propre »</div>
              <span class="time">il y a 12 min</span>
            </div>
            <div class="audit-row">
              <span class="av" style="background-image:url('https://picsum.photos/seed/cb-team-yacine/80/80')"></span>
              <div class="text"><b>Yacine Ba</b> a <span class="verdict rej">rejeté</span> une photo (spam IA · 86%)</div>
              <span class="time">il y a 25 min</span>
            </div>
            <div class="audit-row">
              <span class="av" style="background-image:url('https://picsum.photos/seed/cb-team-cheikh/80/80')"></span>
              <div class="text"><b>Cheikh L.</b> a escaladé un signalement à la commission voirie</div>
              <span class="time">il y a 1 h</span>
            </div>
            <div class="audit-row">
              <span class="av" style="background-image:url('https://picsum.photos/seed/cb-team-mor/80/80')"></span>
              <div class="text"><b>Mor Sène</b> a <span class="verdict ok">approuvé</span> l'album « Pirogues — Plage Nord »</div>
              <span class="time">hier</span>
            </div>
          </div>

          <!-- Stats -->
          <div class="side-panel">
            <h4>Votre journée</h4>
            <div class="stat-grid">
              <div class="stat-cell dark">
                <div class="v">23</div>
                <div class="l">Traités aujourd'hui</div>
              </div>
              <div class="stat-cell">
                <div class="v">2h 14</div>
                <div class="l">Temps moyen</div>
              </div>
              <div class="stat-cell">
                <div class="v" style="color:#1F7A3A">19</div>
                <div class="l">Approuvés</div>
              </div>
              <div class="stat-cell">
                <div class="v" style="color:#B72333">4</div>
                <div class="l">Rejetés</div>
              </div>
            </div>
            <div class="kb-help">
              <span>Raccourcis</span>
              <kbd>A</kbd> Approuver <span class="sep">·</span>
              <kbd>R</kbd> Rejeter <span class="sep">·</span>
              <kbd>E</kbd> Escalader <span class="sep">·</span>
              <kbd>↑↓</kbd> Naviguer
            </div>
          </div>

        </aside>

      </div>
    </div>
`;

const Moderation = () => {
  useEffect(() => {
    // Filter chips behavior (shared pattern from mockups)
    const groups = document.querySelectorAll('.admin-page .seg, .admin-page .filterbar');
    const handler = (e) => {
      const c = e.target.closest('.chip, .seg button, .pill-btn');
      if (!c) return;
      const group = c.parentElement;
      if (!group) return;
      const siblings = group.querySelectorAll('.chip, button');
      let sameGroup = true;
      siblings.forEach((s) => { if (!group.contains(s)) sameGroup = false; });
      if (sameGroup) {
        siblings.forEach((s) => s.classList.remove('on'));
        c.classList.add('on');
      }
    };
    groups.forEach((g) => g.addEventListener('click', handler));
    return () => groups.forEach((g) => g.removeEventListener('click', handler));
  }, []);

  return (
    <div className="admin-page admin-page-moderation" dangerouslySetInnerHTML={{ __html: HTML }} />
  );
};

export default Moderation;
